/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/setVatNumber.scss';

import {ChangeFunction, CloseButton, ErrorType, Loader, WithBackground} from '@dvrd/dvr-controls';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

import {BluemateButton, BluemateInput} from '../../../controls';

interface Props {
    onChange: ChangeFunction<string>;
    onFocus: FocusEventHandler;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onClose: MouseEventHandler;
    vatNumber: string;
    active: boolean;
    loading: boolean;
    error: ErrorType;
}

export default function SetVatNumber(props: Props) {
    const {t} = useTranslation();
    const {error, vatNumber, onFocus, active, onClose, loading, onChange, onSubmit} = props;

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading} />
                <p>
                    {t(
                        'settings.subscription.vatNumberInfo',
                        'Voor het starten van het abonnement hebben we jouw BTW-nummer nodig. Vul deze hieronder in om door te gaan.'
                    )}
                </p>
                <BluemateInput
                    onChange={onChange}
                    value={vatNumber}
                    label={t('settings.subscription.vatNumber', 'BTW-nummer')}
                    inputProps={{placeholder: 'NL012345678B01'}}
                    onFocus={onFocus}
                    onEnter={onSubmit}
                    autoFocus
                />
                <label className='error-label'>{error}</label>
            </div>
        );
    }

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='set-vat-number default-popup'>
                <div className='header-container'>
                    <label className='header-title'>
                        {t('settings.subscription.vatNumberTitle', 'BTW-nummer instellen')}
                    </label>
                    <CloseButton onClick={onClose} />
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BluemateButton
                        onClick={onClose}
                        label={t('settings.subscription.cancel', 'Annuleren')}
                        disabled={loading}
                        secondary
                    />
                    <BluemateButton
                        onClick={onSubmit}
                        label={t('settings.subscription.continue', 'Doorgaan')}
                        disabled={loading || !vatNumber.length}
                    />
                </div>
            </div>
        </WithBackground>
    );
}
